module.exports = __webpack_public_path__ + "static/media/cabo-epr.1d304cf6.png";